import React from 'react';
import PropTypes from 'prop-types';
import { PupAvatar } from '@web/components';
import {
  StyledSummaryItem,
  OrderInfoGroup,
  OrderInfoList,
  StyledTitleAndPrice,
  OrderPricing,
  SummaryItemTitle,
  Price,
  ListItemsContainer,
  StyledLiContainer,
  AddonsTitle,
  StrikePrice,
} from './SummaryItem.styles';
import { Section, SectionTitle } from './styles.js';
import { StyledLi } from './StyledLi';

export const SummaryItem = ({
  breeds,
  price,
  discountedPrice,
  period,
  pricePerPeriod,
  backgroundColor,
  title,
  summaryList,
  addons,
  starterBox,
  subscription,
}) => {
  return (
    <>
      <StyledSummaryItem columns={3}>
        <PupAvatar
          {...{
            breeds,
            color: backgroundColor,
            variant: 'circle',
            fullBleed: true,
          }}
        />
        <OrderInfoGroup>
          <OrderInfoList>
            <StyledTitleAndPrice>
              <SummaryItemTitle>{title}</SummaryItemTitle>
              <OrderPricing>
                <StrikePrice>{price}</StrikePrice>
                <Price>{discountedPrice}</Price>
                {pricePerPeriod && (
                  <Price>
                    {pricePerPeriod}/{period}
                  </Price>
                )}
              </OrderPricing>
            </StyledTitleAndPrice>
            <ListItemsContainer>
              {summaryList?.map(({ label, content }, index) => {
                // temp solution to remove 'Next Delivery' for Recurring Subscription Box (as BE does not pass correct date)
                // All we must do to revert is remove the below check (if/else) statement and use the default return
                if (starterBox && label === 'Next Delivery') {
                  return null;
                } else {
                  return (
                    <StyledLiContainer key={index}>
                      <strong>{label}: </strong>
                      {content}
                    </StyledLiContainer>
                  );
                }
              })}
              {starterBox && !!addons?.length && (
                <AddonsTitle>Subscription Extras</AddonsTitle>
              )}
              {starterBox &&
                addons?.map(
                  (
                    {
                      product_name,
                      price,
                      discounted_price,
                      quantity,
                      product_type,
                    },
                    index,
                  ) => (
                    <StyledLi
                      key={index}
                      product_name={product_name}
                      quantity={quantity}
                      product_type={product_type}
                      pricePerPeriod={pricePerPeriod}
                      period={period}
                      price={price}
                      discounted_price={discounted_price}
                    />
                  ),
                )}
            </ListItemsContainer>
          </OrderInfoList>
        </OrderInfoGroup>
      </StyledSummaryItem>
      {subscription && !!addons?.length && (
        <Section>
          <ListItemsContainer>
            <SectionTitle>Extras</SectionTitle>
            {addons?.map(
              ({ product_name, price, quantity, product_type }, index) => (
                <StyledLi
                  key={index}
                  product_name={product_name}
                  quantity={quantity}
                  product_type={product_type}
                  discounted_price={price}
                />
              ),
            )}
          </ListItemsContainer>
        </Section>
      )}
    </>
  );
};

SummaryItem.displayName = 'SummaryItem';
SummaryItem.propTypes = {
  breeds: PropTypes.arrayOf(PropTypes.string.isRequired),
  price: PropTypes.string,
  discountedPrice: PropTypes.string,
  pricePerPeriod: PropTypes.string,
  period: PropTypes.string,
  backgroundColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  summaryList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
  addons: PropTypes.array,
  starterBox: PropTypes.bool,
  subscription: PropTypes.bool,
};
